import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  docTitle: "",
  docClass: "",
  docFormat: "",
  classFormat: "",
  viewRequired: false,
  formatRequired: false,
  objConRequired: false,
  restrictedAccess: "N",
  docReleaseStatus: "",
  uploadFiles: [],
  uploadFileCount: 0,
  docClassFormatList: [],
  docFileTypeList: [],
  logicalUnitList: [],
  attachedDocInfo: null,
  viewCopydDocInfo: null,
};

const basicInfoSlice = createSlice({
  name: "checkin/basicInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_DOCTITLE_CHANGED", (state, action) => {
        state.docTitle = action.payload;
      })
      .addCase("ON_DOCCLASS_CHANGED", (state, action) => {
        state.docClass = action.payload;
      })
      .addCase("ON_DOCFORMAT_CHANGED", (state, action) => {
        state.docFormat = action.payload;
      })
      .addCase("ON_DOCDOCFORMAT_CHANGED", (state, action) => {
        state.classFormat = action.payload;
      })
      .addCase("ON_VIEWREQUIRED_CHANGED", (state, action) => {
        state.viewRequired =
          action.payload !== undefined &&
          action.payload !== null &&
          action.payload.toUpperCase() === "Y";
      })
      .addCase("ON_FORMATREQUIRED_CHANGED", (state, action) => {
        state.formatRequired =
          action.payload !== undefined &&
          action.payload !== null &&
          action.payload.toUpperCase() === "Y";
      })
      .addCase("ON_OBJCONREQUIRED_CHANGED", (state, action) => {
        state.objConRequired =
          action.payload !== undefined &&
          action.payload !== null &&
          action.payload.toUpperCase() === "Y";
      })
      .addCase("ON_RESTRICTEDACCESS_CHANGED", (state, action) => {
        const value = action.payload;
        state.restrictedAccess =
          value !== undefined && value !== null && `${value}`.toUpperCase() === "Y"
            ? "Y"
            : "N";
      })
      .addCase("ON_DOCRELEASE_CHANGED", (state, action) => {
        state.docReleaseStatus = action.payload;
      })
      .addCase("ON_FILEUPLOAD_CHANGE", (state, action) => {
        state.uploadFiles = action.payload;
      })
      .addCase("ON_UPLOADEDFILE_COUNT_CHANGED", (state, action) => {
        state.uploadFileCount = action.payload;
      })
      .addCase("ON_DOCDOCFORMATLIST_CHANGED", (state, action) => {
        state.docClassFormatList = action.payload;
      })
      .addCase("ON_FILETYPES_CHANGED", (state, action) => {
        state.docFileTypeList = action.payload;
      })
      .addCase("ON_LOGICALUNITLIST_CHANGED", (state, action) => {
        state.logicalUnitList = action.payload;
      })
      .addCase("ON_ATTACHED_DOC_INFO", (state, action) => {
        state.attachedDocInfo = action.payload;
      })
      .addCase("ON_VIEWCOPY_DOC_INFO", (state, action) => {
        state.viewCopydDocInfo = action.payload;
      });
  },
});

export default basicInfoSlice.reducer;
